export class Aplicacao {
  nome: string;
  versao: string;
  data: string;

  public static createInstance(dados: {}): Aplicacao {
    const item: Aplicacao = new Aplicacao();
    Object.assign(item, dados);
    return item;
  }

  constructor() {
    this.nome = '';
    this.versao = '';
    this.data = '';
  }
}
